<template>
  <b-modal id="edit-app-header" size="xlg" title="App Header" hide-footer>
    <b-row>
      <b-col cols="8">
        <div id="update-app-header" class="modal-form">
          <b-row no-gutters>
            <b-col sm="12" md="3">
              <h6 class="main-label">Title</h6>
            </b-col>
            <b-col>
              <b-form-group
                id="titleGroup"
                label="Enter Header Title"
                label-for="title"
                class="secondary-label"
              >
                <b-form-input id="title" type="text" v-model="form.title" maxlength="30" required></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col>
              <hr class="form-divider" />
            </b-col>
          </b-row>
          <b-row no-gutters>
            <b-col sm="12" md="3">
              <h6 class="main-label">Image</h6>
              <span class="label-helper d-inline-block">(350 x 200)</span>
            </b-col>
            <b-col>
              <b-form-group>
                <div id="class-upload-image" class="border" v-b-modal.appHeaderUploadImage>
                  <!-- Use an if else here for showing an image -->
                  <img v-if="image === ''" :src="form.image" alt="App Header Image" />
                  <img v-else :src="image" alt="App Header Image" />
                  <div class="upload-icon rounded-circle border"></div>
                </div>
              </b-form-group>
            </b-col>
          </b-row>
          <div style="margin-top: 270px;">
            <b-row no-gutters class="modal-footer pb-0">
              <b-col>
                <b-button
                  variant="ghost"
                  class="btn-cancel"
                  style="margin-right: .25rem;"
                  @click="clearFields"
                >Cancel</b-button>
              </b-col>
              <b-col class="text-right">
                <b-button variant="primary" style="margin-left: .25rem;" @click="sendForm">Publish Now</b-button>
              </b-col>
            </b-row>
          </div>
        </div>
      </b-col>
      <b-col cols="4">
        <div id="app-header-mobile-outline" class="mx-auto">
          <div id="app-header-mobile-outline-content" class="mx-auto d-block">
            <div class="banner">
              <img v-if="image === ''" :src="form.image" alt="Sample Badge" />
              <img v-else :src="image" alt="Sample Badge" />
            </div>
            <div class="pt-3 px-2">
              <h6 class="app-header-title">{{ (form.title == "") ? 'App Header Title' : form.title}}</h6>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "edit-app-header",
  props: ["form", "image"],
  computed: {
    ...mapState("purchasePackages", ["errors"])
  },
  methods: {
    async sendForm() {
      this.$store.dispatch("purchasePackages/resetErrors");

      let param = {
        title: this.form.title
      };

      if (this.image !== "") {
        param.image = this.image.replace(/^data:image\/\w+;base64,/, "");
      }

      let _this = this;
      await this.$store
        .dispatch("purchasePackages/updateAppHeader", param)
        .then(function() {
          if (_this.errors == null) {
            _this.clearFields();
            _this.hideModal("edit-app-header");
            _this.getAppHeader();
          }
        });
    },
    async getAppHeader() {
      await this.$store.dispatch("purchasePackages/getAppHeader");
    },
    errorMessage(field) {
      if (this.errors == null) {
        return "";
      }

      return this.errors.errors[field];
    },
    isValid(field) {
      if (this.errors == null) {
        return false;
      }
      return this.errors.errors[field] ? false : true;
    },
    showModal(modal) {
      this.$root.$emit("bv::show::modal", modal);
    },
    hideModal(modal) {
      this.$root.$emit("bv::hide::modal", modal);
    },
    clearFields() {
      this.hideModal("edit-app-header");
      this.$store.dispatch("purchasePackages/resetErrors");

      this.$emit("clearImage", true);
    }
  }
};
</script>
